export enum ImprovementType{
    VerymuchImp=1, 
    Improved=2,
    MinimallyImp=3,
    Unchanged=4,
    MinimallyWorse=5,
    Worse=6,
    VeryMuchWorse=7
}